import { MapType } from '@/util/types'

export const iconMap: MapType = {
  1: 'iconfont icon-VR',
  2: 'iconfont icon-2d',
  // 3: 'iconfont icon-moxing',
  3: 'iconfont icon-3d-model',
  4: 'iconfont icon-quanjingtu'
}

export const linkPrefixMap: MapType = {
  1: '/pad/res/',
  2: '/pad/videos/',
  3: '/pad/model/',
  4: 'pad/model/',
}
